import SpriteSymbol from "../../../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "marketing",
  "use": "marketing-usage",
  "viewBox": "0 0 31.9 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.9 28\" id=\"marketing\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M30 21a1 1 0 01-1 1l-3-.5v-17l3-.5a1 1 0 011 1zM3 18a1 1 0 01-1-1V9a1 1 0 011-1l21-3.2v16.5zm11 7.8l-6-1.5v-3.4l6 .9zM30 0v2L2 6a2 2 0 00-2 2v10a2 2 0 002 2l4 .6V25a1 1 0 001 1l7.7 2h.5a1 1 0 00.7-.9v-5l14 2v2h2V0z\" data-name=\"Page-1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol